module.exports = __webpack_public_path__ + "static/img/point_icon_09.40ebbb2d.svg";